import React, { useEffect } from 'react';
import { useVariant, useFlagsStatus } from '@unleash/proxy-client-react';
import { useDispatch } from 'react-redux';
import { bool, number } from 'prop-types';
import Urls from 'mangools-commons/dist/constants/Urls';
import Timer from 'components/messages/topLevel/newUserMessage/Timer';
import { gtmTrack } from 'actions/analyticsActions';
import CampaignBannerType from 'types/CampaignBannerType';

import upgradeImg from 'images/gift.svg';

function NewUserMessage(props) {
    const dispatch = useDispatch();
    const variant = useVariant('early-bird-ab-test');
    const isEarlyBirdVisible = props.visible && !props.campaignBanner;

    useEffect(() => {
        if (isEarlyBirdVisible) {
            dispatch(
                gtmTrack({
                    event: 'unleash',
                    ABTestName: 'earlybird',
                    ABTestVariant: variant.name,
                }),
            );
        }
    }, [isEarlyBirdVisible]);

    if (props.visible) {
        if (props.campaignBanner) {
            return (
                <div className="mg-page-message">
                    <div className="uk-container uk-container-center uk-flex uk-flex-middle uk-flex-center">
                        <img
                            src={upgradeImg}
                            alt="Upgrade subscription"
                            width="18"
                            className="mg-margin-r-10"
                            style={{ marginTop: '-3px' }}
                        />
                        <strong>{props.campaignBanner.text}&nbsp;</strong>
                        <a
                            className="mg-btn is-orange is-gradient is-pill is-xsmall mg-margin-l-15"
                            href={`${props.campaignBanner.url}?ref=msg-app-sp`}
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            {props.campaignBanner.buttonText}
                        </a>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="mg-page-message">
                    <div className="uk-container uk-container-center uk-flex uk-flex-middle uk-flex-center">
                        <img
                            src={upgradeImg}
                            alt="Upgrade subscription"
                            width="18"
                            className="mg-margin-r-10"
                            style={{ marginTop: '-3px' }}
                        />
                        <strong>Get 10% discount&nbsp;</strong> on Mangools SEO tools!&nbsp;
                        <Timer limit={props.timerLimitSeconds} />
                        <span className="uk-hidden-medium mg-margin-l-10">Hurry up, time is running.&nbsp;</span>
                        <a
                            className="mg-btn is-orange is-gradient is-pill is-xsmall mg-margin-l-15"
                            href={`${Urls.MANGOOLS_PLANS_AND_PRICING_URL}?ref=msg-app-sp`}
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            Grab discount
                        </a>
                    </div>
                </div>
            );
        }
    } else {
        return null;
    }
}

NewUserMessage.propTypes = {
    campaignBanner: CampaignBannerType,
    timerLimitSeconds: number.isRequired,
    visible: bool.isRequired,
};

export default NewUserMessage;
